import React, { useEffect, useState } from 'react';
import { TextField, Button } from '@mui/material';
import { SingleSelect } from '../select-types/SingleSelect.js';
import { UtilService } from '../../services/UtilService.js';
import Excel from './Excel.js';
import { Item } from '../../models.ts';
import EditCalculator from './EditCalculator.js';

const PorchCalculator = ({ porchObj, porchMap, isAdmin, handleSubmit }) => {
  const [porchState, setPorchState] = useState({});
  const [disableCalculate, setDisableCalculate] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const utilService = new UtilService();

  useEffect(() => {
    if (porchObj && porchMap) {
      let obj = { ...porchObj };
      porchObj.fields.forEach(field => {
        obj[field.id] = { ...field };
        if (field.id === 'Length' || field.id === 'Width') {
          obj[field.id].selection = new Item();
        }
      });
      setPorchState(obj);
    }

    return () => {
      setPorchState({});
      setDisableCalculate(true);
    };
  }, [porchObj, porchMap]);

  function handleChange(field, value) {
    switch (field.type) {
      case 'select':
        let item = porchMap[field.collection].find(i => i.id === value);
        field.selection = JSON.parse(JSON.stringify(item));
        break;
      case 'text':
      case 'number':
        if (!field.selection) {
          field.selection = new Item();
        }
        field.selection.value = field.type === 'number' ? Number(value) : value;
        break;
      default:
        break;
    }

    if (field.id === 'porchBase') {
      const porchLattice = porchState['porchLattice'];
      if (field.selection.id === '1' || field.selection.id === '2') {
        porchLattice.disabled = true;
        let selection = porchMap[field.collection].find(i => i.id === '1');
        porchLattice.selection = selection;
      } else {
        porchLattice.disabled = false;
      }
      const porchFloor = porchState['floor'];
      if (field.selection.id === '2' || field.selection.id === '3') {
        porchFloor.show = porchFloor.required = true;
      } else {
        porchFloor.show = porchFloor.required = false;
        porchFloor.selection = undefined;
      }
      porchState['floor'] = porchFloor;
    }

    setPorchState({ ...porchState, [field.id]: { ...field } });
    checkDisabled();
  }

  function checkDisabled() {
    let disabled = false;
    if (porchState?.fields?.length) {
      for (let field of porchState.fields) {
        if (porchState[field.id].show && porchState[field.id].required && !disabled) {
          if (field.type === 'select') {
            disabled = porchState[field.id].selection === undefined;
          } else if (field.type === 'text') {
            disabled = !porchState[field.id].selection?.value?.length;
          } else if (field.type === 'number') {
            disabled = !porchState[field.id].selection?.value || porchState[field.id].selection?.value === 0;
          }
        }
      }
    }
    setDisableCalculate(disabled);
  }

  function calculate() {
    let newObj = handleSubmit(porchState, porchMap);
    setPorchState(newObj);
  }

  function onEdit() {
    document.getElementById('container').style.width = isEditing ? '300px' : '90vw';
    setIsEditing(!isEditing);
  }

  if(isEditing) {
    return (
      <EditCalculator title={'Porch Calculator'}
        calculator={porchState}
        itemList={porchMap}
        onFinish={onEdit}
      />
    )
  } else {
    return (
      <div>
        <div>
          {isAdmin &&
            <Button variant='outlined' onClick={onEdit}>
              {isEditing ? 'Done' : 'Edit'}
            </Button>
          }
          <h1>Porch Calculator</h1>
        </div>
        <div>
          {porchState.fields?.length &&
            porchState.fields.map(field => {
              if (porchState[field.id].show) {
                return (
                  <div key={field.id}>
                    {field.type === 'select' &&
                      <SingleSelect
                        field={porchState[field.id]}
                        label={field.name}
                        optionList={porchMap[field.collection]}
                        handleChange={handleChange}>
                      </SingleSelect>
                    }
                    {(field.type === 'text' || field.type === 'number') &&
                      <TextField
                        error={porchState[field.id].required &&
                          (!porchState[field.id].selection?.value || porchState[field.id].selection?.value === 0)}
                        label={field.name}
                        disabled={porchState[field.id].disabled}
                        defaultValue={porchState[field.id].value || ''}
                        helperText={null}
                        required={field.required}
                        onChange={(e) => handleChange(field, e.target.value)}
                        variant="standard"
                      />
                    }
                    {!field.type &&
                      <div className='total'>
                        <span>{field.name} = </span>
                        <span>{utilService.formatCurrency(porchState[field.property]) || 0}</span>
                      </div>
                    }
                  </div>
                )
              } else {
                return null;
              }
            })
          }
        </div>
        <div className='buttonGroupSpaced'>
          <Button variant="outlined"
            onClick={calculate}
            disabled={disableCalculate}
          >
            Calculate
          </Button>
          {!disableCalculate && porchState.total > 0 &&
            <Excel calc={porchState}></Excel>
          }
        </div>
      </div>
    )
  }
};

export default PorchCalculator;